import { render, staticRenderFns } from "./SessionExpireModal.vue?vue&type=template&id=37645584&"
import script from "./SessionExpireModal.vue?vue&type=script&lang=js&"
export * from "./SessionExpireModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports